<template>
<v-container>
    <v-row>
        <v-col>
                <p>
                    Возвращает прогноз по территории. Где presetId – это идентификатор пресета.
                </p>

                <div class="text-subtitle-1">Заголовки запроса</div>
                <v-simple-table>
                    <thead>
                    <tr>
                        <td><b>Заголовок</b></td>
                        <td><b>Описание</b></td>
                        <td><b>Пример значения</b></td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Authorization</td>
                        <td>JWT токен доступа</td>
                        <td>
                            Bearer eyJhbGciOiJSUzI1NiIsImtp...
                        </td>
                    </tr>
                    <tr>
                        <td>Accept-Encoding</td>
                        <td>
                            Вы можете указать параметр gzip для сжатия ответа. Настоятельно рекомендуем использовать этот заголовок!
                            Например, если без сжатия, ответ занимает 4 мегабайта, то с gzip сжатием он будет занимать около 150 килобайт.
                        </td>
                        <td>gzip</td>
                    </tr>
                    </tbody>
                </v-simple-table>
                
                <div class="text-subtitle-1">Типы запросов</div>
                
                <v-simple-table>
                    <thead>
                    <tr>
                        <td><b>Запрос</b></td>
                        <td><b>Описание</b></td>
                        <td><b>Пример</b></td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>По координатам и домену</td>
                        <td>{lat} - широта; {lon} - долгота</td>
                        <td>
                            <code>curl -H 'Authorization: Bearer eyJhbGciOiJSUzI1NiIsImtp...' '{{ $settings.VUE_APP_GATEWAY_SERVICE_ENDPOINT }}/api/1.2/forecast/preset/5fd76f29552c452a796cb600'</code>
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>
                
                <div class="text-subtitle-1">Ответ</div>
                
                <v-simple-table class="table">
                    <thead>
                    <tr>
                        <td><b>Пример ответа</b></td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                    <json-viewer
                      :value="response"
                      copyable
                      boxed
                      sort></json-viewer> 
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>
        </v-col>
    </v-row>

    <v-row>
        <v-col>
            <v-card>                
                <div class="text-subtitle-1">Общие сведения</div>
                <p>                
                    WAPI позволяет осуществлять запросы по указанной территории, имеющей любую произвольную форму. Такая территория, по которой можно выполнить запрос прогноза, называется preset (пресет).
                </p>                
                <p>
                    Получить список активных территорий можно с помощью API.
                </p>
            </v-card>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
export default {
    data: function() {
        return {
            response:{
  "status_code": 200,
  "result": {
    "points": [
      {
        "x": 40.385668955824464,
        "y": 46.96264549110353
      },
      {
        "x": 40.385668955824464,
        "y": 46.94597879110353
      },
      {
        "x": 40.385668955824464,
        "y": 46.929312091103526
      }
    ],
    "parameters": [
        {
          "level_type": "surface",
          "level": 0,
          "pname": "2 metre dewpoint temperature",
          "sname": "2d",
          "unit": "c"
        },
        {
          "level_type": "surface",
          "level": 0,
          "pname": "2 metre temperature",
          "sname": "2t",
          "unit": "c"        
        }
      ],
      "ref_time": "2021-12-25T00:00:00Z",
      "predicts": [
        60,
        120,
        180,
        240
      ],
      "values": [
        -9.342007090426012,
        -8.750049884363474,
        -8.159942422098027,
        -7.576131949143217
      ]
    }
  }

        }
    }
}
</script>